<div class="d-flex flex-column" style="height:calc(100vh - 194px)" *ngIf="!objectiveService.showGroupsCardView">
    <div class="row">
        <div class="col-12">
            <div class="content d-flex p-4 mb-4">
                <div class="d-flex flex-column" style="width:180px">
                    <div class="font-size-12 lato-bold color-no2Pencil mb-3" cvLocalizedText langSection="Objectives" langKey="List_By">List by:</div>

                    <div class="d-flex">
                        <input type="radio" class="mr-0" style="width:16px; height:16px" [(ngModel)]="controlType" (ngModelChange)="clearSearch()" value="emp" id="objectiveGroupEmp" />
                        <label for="objectiveGroupEmp" class="color-whaleTail pl-2" *ngIf="objectiveService.empGroupLabels != null" cvLocalizedText langSection="Objectives" langKey="Employee"></label>
                    </div>

                    <div class="d-flex">
                        <input type="radio" class="mr-0" style="width:16px; height:16px" [(ngModel)]="controlType" (ngModelChange)="clearSearch()" value="rec" id="objectiveGroupRec" />
                        <label for="objectiveGroupRec" class="color-whaleTail pl-2" *ngIf="objectiveService.recGroupLabels != null" cvLocalizedText langSection="Objectives" langKey="Recording"></label>
                    </div>

                    <div class="d-flex">
                        <input type="radio" class="mr-0" style="width:16px; height:16px" [(ngModel)]="controlType" (ngModelChange)="clearSearch()" value="attr" id="objectiveGroupAttr" />
                        <label for="objectiveGroupAttr" class="color-whaleTail pl-2" cvLocalizedText langSection="Objectives" langKey="Attribute">Attribute</label>
                    </div>
                </div>

                <div class="d-flex flex-column">
                    <div class="lato-bold font-size-12 color-no2Pencil mb-3" cvLocalizedText langSection="Objectives" langKey="Filter_By">Filter by:</div>

                    <cv-group-selector pageName="ObjectivesAdmin" [baseGroupType]="0" [showSelectedToggle]="true" [hasSelectedToggle]="true" [hasMultiSelect]="false" *ngIf="controlType == 'emp'"></cv-group-selector>

                    <cv-group-selector pageName="ObjectivesAdmin" [baseGroupType]="1" [showSelectedToggle]="true" [hasSelectedToggle]="true" [hasMultiSelect]="false" *ngIf="controlType == 'rec'"></cv-group-selector>

                    <div class="nonModuleContainer mb-2" *ngIf="controlType == 'attr'">
                        <cv-attribute-selector pageName="ObjectivesAdmin" [attributeType]="1" [showSelectedToggle]="false" (selectedAttributesChanged)="onSelectedAttributesChanged($event)"
                                               (noAttributes)="noAttributes = $event"></cv-attribute-selector>
                    </div>

                    <div><button type="button" class="btn btn-secondary" (click)="loadGroups()" [disabled]="controlType == 'attr' && noAttributes"
                                 cvLocalizedText langSection="Objectives" langKey="Load_Groups">Load Groups</button></div>
                </div>
            </div>
        </div>
    </div>

    <!-- Grid -->
    <div class="row flex-grow-1">
        <div class="col-12 d-flex position-relative">
            <cv-loader *ngIf="objectiveService.groupViewLoading"></cv-loader>
            <ag-grid-angular #objectiveGroupsAssignedGrid [gridOptions]="gridOptions" class="ag-theme-balham flex-fill" *ngIf="gridOptions != null"></ag-grid-angular>
        </div>
    </div>
</div>

<cv-objective-groups-card-view *ngIf="objectiveService.showGroupsCardView"></cv-objective-groups-card-view>
